import { getDefaultSelectedLanguage } from '../../core/services/storage.service'
import {
  helvetiaCloHome,
  legalInfo,
  privacyPolicy,
  termsAndConditions,
} from './environmentConst.provider'

export const goToPrivacyPolicyLink = () => {
  const lang = getDefaultSelectedLanguage()
  window.open(privacyPolicy[lang], '_blank')
}

export const goToLeaglInfo = () => {
  const lang = getDefaultSelectedLanguage()
  window.location.href = legalInfo[lang]
}

export const goToTermsAndConditionsLink = () => {
  const lang = getDefaultSelectedLanguage()
  window.open(termsAndConditions[lang], '_blank')
}

export const goToHelvetiaLandingPage = () => {
  const lang = getDefaultSelectedLanguage()
  window.location.href = helvetiaCloHome[lang]
}
